import React from "react";
import { twMerge } from "tailwind-merge";

interface EditorIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const EditorIcon: React.FC<EditorIconProps> = ({
  width = 40,
  height = 48,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 42"
      fill="none"
      className={twMerge(className, "text-primary-foreground")}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_2102_4406)">
        <path
          d="M4 6C4 2.68629 6.68629 0 10 0L28 0L36 8V34C36 37.3137 33.3137 40 30 40H10C6.68629 40 4 37.3137 4 34V6Z"
          fill="currentColor"
        />
        <path
          d="M10 0.75H27.6895L35.25 8.31055V34C35.25 36.8995 32.8995 39.25 30 39.25H10C7.10051 39.25 4.75 36.8995 4.75 34V6C4.75 3.10051 7.10051 0.75 10 0.75Z"
          stroke="#FF891D"
          strokeWidth="1.5"
        />
      </g>
      <path d="M27 0L36 9H31C28.7909 9 27 7.20914 27 5V0Z" fill="#FF891D" />
      <g clipPath="url(#clip0_2102_4406)">
        <path
          d="M12.5822 16.667C12.5822 16.0439 12.8292 15.4455 13.2687 15.0039L15.004 13.2686C15.4457 12.8291 16.0441 12.582 16.6671 12.582C17.2121 12.5821 17.7377 12.7708 18.1564 13.1123L18.3292 13.2686L21.1974 16.1357C21.4903 16.4286 21.4903 16.9044 21.1974 17.1973C20.9045 17.4902 20.4288 17.4902 20.1359 17.1973L17.2706 14.3311C17.1102 14.1716 16.8933 14.0822 16.6671 14.082C16.4408 14.082 16.2231 14.1715 16.0626 14.3311L14.3302 16.0635C14.1713 16.2239 14.0822 16.4411 14.0822 16.667C14.0823 16.8927 14.1714 17.1092 14.3302 17.2695L17.1974 20.1357C17.4903 20.4286 17.4903 20.9044 17.1974 21.1973C16.9045 21.4902 16.4288 21.4902 16.1359 21.1973L13.2687 18.3291C12.8293 17.8876 12.5823 17.2899 12.5822 16.667Z"
          fill="#FF891D"
        />
        <path
          d="M18.1361 14.1356C18.4289 13.8428 18.9037 13.8429 19.1966 14.1356C19.4895 14.4285 19.4895 14.9033 19.1966 15.1962L17.8636 16.5292C17.5707 16.8221 17.096 16.8221 16.8031 16.5292C16.5104 16.2363 16.5102 15.7615 16.8031 15.4686L18.1361 14.1356Z"
          fill="#FF891D"
        />
        <path
          d="M24.8027 20.8036C25.0956 20.5107 25.5704 20.5108 25.8633 20.8036C26.1562 21.0965 26.1562 21.5712 25.8633 21.8641L24.5303 23.1971C24.2374 23.49 23.7626 23.49 23.4697 23.1971C23.177 22.9042 23.1769 22.4294 23.4697 22.1366L24.8027 20.8036Z"
          fill="#FF891D"
        />
        <path
          d="M22.803 18.8037C23.0959 18.5108 23.5707 18.5108 23.8636 18.8037L26.7308 21.6699C27.6503 22.5894 27.6503 24.0784 26.7308 24.998L24.9974 26.7314C24.0778 27.6509 22.5888 27.6509 21.6693 26.7314L18.803 23.8642C18.5102 23.5713 18.5102 23.0965 18.803 22.8037C19.0959 22.5108 19.5707 22.5108 19.8636 22.8037L22.7308 25.6699C23.0645 26.0036 23.6021 26.0036 23.9359 25.6699L25.6693 23.9365C26.003 23.6027 26.003 23.0652 25.6693 22.7314L22.803 19.8642C22.5102 19.5713 22.5102 19.0965 22.803 18.8037Z"
          fill="#FF891D"
        />
        <path
          d="M25.9164 15.2139C25.9164 14.9145 25.7979 14.6268 25.5863 14.415C25.3746 14.2032 25.087 14.084 24.7875 14.084C24.488 14.0839 24.2005 14.2033 23.9887 14.415L23.9877 14.4141L15.0912 23.3145C15.0241 23.3813 14.9729 23.4633 14.9447 23.5537L14.9457 23.5547L14.2914 25.709L16.4467 25.0557L16.5131 25.0303C16.5782 25.0014 16.6381 24.9607 16.6889 24.9102L25.5853 16.0117C25.797 15.8001 25.9162 15.5132 25.9164 15.2139ZM27.4164 15.2139C27.4162 15.9109 27.1396 16.5794 26.6469 17.0723L17.7475 25.9727C17.506 26.2133 17.2093 26.391 16.8832 26.4902L13.9799 27.3711C13.7927 27.4274 13.5923 27.4324 13.4027 27.3848C13.2132 27.3371 13.0401 27.2386 12.9017 27.1006C12.7634 26.9624 12.6646 26.7891 12.6166 26.5996C12.5686 26.41 12.5723 26.2108 12.6283 26.0234L12.6293 26.0205L13.5101 23.1191L13.5111 23.1172C13.6111 22.791 13.7892 22.4939 14.0307 22.2529L22.9281 13.3535C23.4212 12.8605 24.0902 12.5839 24.7875 12.584C25.4848 12.5841 26.1538 12.8613 26.6469 13.3545C27.1398 13.8476 27.4165 14.5166 27.4164 15.2139Z"
          fill="#FF891D"
        />
        <path
          d="M21.4697 14.8037C21.7626 14.5108 22.2373 14.5108 22.5302 14.8037L25.1972 17.4706C25.4898 17.7636 25.49 18.2384 25.1972 18.5312C24.9044 18.824 24.4296 18.8238 24.1367 18.5312L21.4697 15.8642C21.1768 15.5713 21.1768 15.0965 21.4697 14.8037Z"
          fill="#FF891D"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_2102_4406"
          x="0"
          y="-1"
          width="40"
          height="49"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="4"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2102_4406"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="multiply"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2102_4406"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2102_4406"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="multiply"
            in2="shape"
            result="effect2_innerShadow_2102_4406"
          />
        </filter>
        <clipPath id="clip0_2102_4406">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
